function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPeopleChildFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.366 26.008H9.635a1 1 0 01-1-1c0-3.56 1.492-6.805 3.896-8.468a1 1 0 011.137 1.645c-1.626 1.126-2.745 3.344-2.985 5.823h10.635c-.241-2.479-1.36-4.697-2.986-5.823a1 1 0 111.138-1.645c2.403 1.663 3.896 4.908 3.896 8.468a1 1 0 01-1 1zM16 7.992a2.917 2.917 0 00-2.914 2.914A2.917 2.917 0 0016 13.82a2.917 2.917 0 002.914-2.914A2.917 2.917 0 0016 7.992zm0 7.828a4.92 4.92 0 01-4.914-4.914A4.92 4.92 0 0116 5.992a4.92 4.92 0 014.914 4.914A4.92 4.92 0 0116 15.82z",
    fill: props.color
  }));
}

export default SvgIconPeopleChildFilled;